/**
 * Build slide image URL: `{base}/{templateKey}/P1.jpg` (matches PDF / seed HTML).
 * @param {string} imageBaseUrl - From API `proposalTemplateImageBaseUrl` (no trailing slash)
 * @param {string} templateKey - gec | kbt | sw
 * @param {string} fileKey - e.g. P1, P12
 */
export function proposalSlideImageUrl(imageBaseUrl, templateKey, fileKey) {
  if (!imageBaseUrl || !templateKey || !fileKey) return null;
  const base = String(imageBaseUrl).replace(/\/$/, "");
  const key = String(templateKey).trim();
  const file = String(fileKey).trim();
  return `${base}/${key}/${file}.jpg`;
}
